import { Link } from "react-router-dom";
import { SITE } from "@/lib/site";

const CTABanner = ({
  eyebrow = "Ready when you are",
  heading = "Let's talk about what your family needs.",
  body = "A free, no-pressure home assessment with a senior member of our team. We'll listen first, then explain exactly what's possible.",
  variant = "teal", // 'teal' | 'cream'
  testId = "cta-banner",
}) => {
  const isCream = variant === "cream";
  return (
    <section
      data-testid={testId}
      className={`section relative overflow-hidden ${
        isCream ? "bg-[var(--ss-cream)]" : "bg-[var(--ss-teal-700)] text-[var(--ss-cream)] grain"
      }`}
    >
      {/* decorative shells */}
      <div
        className={`absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full ${
          isCream ? "bg-[var(--ss-gold)]/15" : "bg-[var(--ss-teal-600)]/40"
        } blur-3xl pointer-events-none`}
      />
      <div className="container-px max-w-5xl mx-auto relative z-10 text-center">
        <span className={`eyebrow ${isCream ? "" : "eyebrow-on-dark"}`}>
          {eyebrow}
        </span>
        <h2
          className={`font-display text-4xl md:text-6xl mt-5 ${
            isCream ? "text-[var(--ss-teal-800)]" : "text-[var(--ss-cream)]"
          }`}
        >
          {heading}
        </h2>
        <p
          className={`mt-5 text-lg max-w-2xl mx-auto ${
            isCream ? "text-[var(--ss-ink-soft)]" : "text-[var(--ss-cream)]/85"
          }`}
        >
          {body}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/contact#enquiry-form"
            data-testid={`${testId}-book`}
            className="btn btn-gold"
          >
            <i className="fa-regular fa-calendar-check"></i>
            Book a free assessment
          </Link>
          <a
            href={SITE.phoneHref}
            data-testid={`${testId}-call`}
            className={`btn ${isCream ? "btn-outline-dark" : "btn-outline-light"}`}
          >
            <i className="fa-solid fa-phone"></i>
            Call {SITE.phone}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
